import React from "react";
import Section from "@insightfulscience/atomic-react/Section";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import { node } from "prop-types";
import { PostElementParagraph } from "@insightfulscience/atomic-react/PostElement";
import Button from "../Button";

export const SectionStart30DayTrial = ({ children }) => {
	return (
		<Section className="section-try-for-free">
			<Container>
				<Row utility={{ justify: "center" }}>
					<Col spacing={{ pt: 5 }} sx={{ textAlign: "center" }}>
						{children}
					</Col>
				</Row>
			</Container>
		</Section>
	);
};

SectionStart30DayTrial.propTypes = {
	children: node.isRequired,
};

export const SectionStart30DayTrialButton = ({ ...props }) => {
	return <Button.Link {...props} />;
};

SectionStart30DayTrialButton.propTypes = {
	...Button.propTypes,
};

export const SectionStart30DayTrialText = ({ ...props }) => {
	return <PostElementParagraph className="text-color-white" {...props} />;
};

SectionStart30DayTrialText.propTypes = {
	...PostElementParagraph.propTypes,
};
